// ======================================================================
// File Name       : LivePerformanceAction
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { decamelizeKeys, camelizeKeys } from 'humps';
import { ENTERPRISE_NOTICE_LIST } from '../constants/ActionTypes';
import { commonCallApi } from '../utils/ApiUtils';
import * as livePerformance from './httpRequests/livePerformance';
import * as usageSettingLiveRequest from './httpRequests/usageSettingLive';
import * as userAttributeRequests from './httpRequests/userAttribute';
import * as livePerformanceCreators from './actionCreators/livePerformance';
import { SELECT_TARGET_DATA, STRUCTURE_LEVEL } from '../constants';
import { mapUserSecernIdWithGroupName } from '../utils/UserUtils';
import * as userRequest from './httpRequests/user';
import { USER_ATTRIBUTE_TYPE } from '../constants/UserAttributeConstants';
import { USER_CREATE_TYPE } from '../constants/UserConstants';

export function searchLivePerformanceList(paramSearch) {
  return async (dispatch) => {
    let livePerformanceListObj = null;
    let recordNum = 0;
    if (paramSearch.searchInfo.userAttributeSearchText) {
      const responseUserAttribute = await userAttributeRequests.postUserAttributeGetList({
        searchInfo: {
          userAttributeType: USER_ATTRIBUTE_TYPE.LIVE,
          userAttributeKeyNum: paramSearch.searchInfo.userAttributeKeyNum,
          userAttributeSearchText: paramSearch.searchInfo.userAttributeSearchText,
        },
      });
      const userAttributeList = responseUserAttribute && responseUserAttribute.userAttributeList ? responseUserAttribute.userAttributeList : [];
      if (userAttributeList && userAttributeList.length > 0) {
        const liveListForRequest = [];
        for (let i = 0; i < userAttributeList.length; i++) {
          liveListForRequest.push(userAttributeList[i].secernId);
        }
        paramSearch.searchInfo.liveList = liveListForRequest;
      } else {
        return dispatch(livePerformanceCreators.getLivePerformanceList(livePerformanceListObj, recordNum));
      }
    }
    paramSearch.searchInfo.includeCompletedLive = 1;
    const response = await usageSettingLiveRequest.getLiveReservedList(paramSearch);
    recordNum = response && response.recordNum ? response.recordNum : 0;
    livePerformanceListObj = getListLivePerformance(response, livePerformanceListObj);
    if (livePerformanceListObj && Object.prototype.hasOwnProperty.call(livePerformanceListObj, 'allSecernIds')) {
      const allSecernIds = livePerformanceListObj.allSecernIds;
      if (allSecernIds && allSecernIds.length) {
        const paramUserCount = {
          searchInfo: { liveList: livePerformanceListObj.allSecernIds },
        };
        const responseLiveUserList = await livePerformance.getLivePerformanceUserCount(paramUserCount);
        const organizerUserSecernIdList = getOrganizerUserSecernId(livePerformanceListObj);
        if (organizerUserSecernIdList && organizerUserSecernIdList.length > 0) {
          const paramOrganizer = {
            selectTargetData: SELECT_TARGET_DATA.DATA,
            searchInfo: {
              userSecernIdList: organizerUserSecernIdList,
              userCreateType: USER_CREATE_TYPE.DEFINED_AND_REPRESENTATIVE_USER,
            },
          };
          const responseGetOrganizer = await livePerformance.getOrganizerUserSecernId(paramOrganizer);
          livePerformanceListObj = addOrganizerNameToObj(responseGetOrganizer, livePerformanceListObj);
        }
        livePerformanceListObj = getListLivePerformanceUserCount(responseLiveUserList, livePerformanceListObj);
      }
    }
    return dispatch(livePerformanceCreators.getLivePerformanceList(livePerformanceListObj, recordNum));
  };
}

// #7119 START
export function getLivePerformanceDetail(paramSearch) {
  return async (dispatch, getState) => {
    let liveReserveDetail = {};
    const userSecernIdList = [];
    let userAttributeList = [];
    let liveList = {};
    let recordNumRelation = 0;
    const searchData = {
      searchInfo: {},
    };
    searchData.searchInfo.includeCompletedLive = 1;
    searchData.searchInfo.liveList = paramSearch.searchInfo.liveList;
    const resData = await usageSettingLiveRequest.getLiveReservedList(searchData);
    if (resData && resData.liveList && resData.liveList.length) {
      liveReserveDetail = resData.liveList[0];
    }
    if (liveReserveDetail && liveReserveDetail.liveSecernId) {
      userSecernIdList.push(liveReserveDetail.organizerUserSecernId);
      const userAttributeRes = await userAttributeRequests.postUserAttributeGetList({
        searchInfo: {
          userAttributeType: USER_ATTRIBUTE_TYPE.LIVE,
          secernId: liveReserveDetail.liveSecernId,
        },
      });
      if (
        userAttributeRes &&
        userAttributeRes.userAttributeList &&
        userAttributeRes.userAttributeList.length
      ) {
        userAttributeList = userAttributeRes.userAttributeList;
      }
    }
    const responseRelationStatus = await livePerformance.getRelationStatusList(paramSearch);
    if (
      responseRelationStatus &&
      responseRelationStatus.liveStatusList &&
      responseRelationStatus.liveStatusList.length
    ) {
      liveList = responseRelationStatus.liveStatusList.reduce(
        (acc, cur) => {
          if (cur.participantUserSecernId) {
            acc.bySecernId[cur.participantUserSecernId] = cur;
            acc.allSecernIds.push(cur.participantUserSecernId);
          }
          return acc;
        },
        {
          bySecernId: {},
          allSecernIds: [],
        },
      );
      recordNumRelation = responseRelationStatus.recordNum;
    }
    const searchInfo = {
      userSecernIdList,
      userCreateType: USER_CREATE_TYPE.DEFINED_AND_REPRESENTATIVE_USER,
    };
    const userListRes = await userRequest.postUserGetList({
      selectTargetData: SELECT_TARGET_DATA.DATA,
      searchInfo,
    });

    const organizerUserName =
      (userListRes &&
        userListRes.userList &&
        userListRes.userList.length &&
        userListRes.userList[0] &&
        userListRes.userList[0].userName) ||
      '';
    liveReserveDetail.organizerUserName = organizerUserName;
    return dispatch(
      livePerformanceCreators.getLivePerformanceDetail(
        liveList,
        liveReserveDetail,
        userAttributeList,
        recordNumRelation,
      ),
    );
  };
}

export function getLivePerformanceDetailPaging(paramSearch) {
  return async (dispatch, getState) => {
    let liveList = {};
    const responseRelationStatus = await livePerformance.getRelationStatusList(paramSearch);
    if (
      responseRelationStatus &&
      responseRelationStatus.liveStatusList &&
      responseRelationStatus.liveStatusList.length
    ) {
      liveList = responseRelationStatus.liveStatusList.reduce(
        (acc, cur) => {
          if (cur.participantUserSecernId) {
            acc.bySecernId[cur.participantUserSecernId] = cur;
            acc.allSecernIds.push(cur.participantUserSecernId);
          }
          return acc;
        },
        {
          bySecernId: {},
          allSecernIds: [],
        },
      );
    }
    return dispatch(livePerformanceCreators.getLivePerformanceDetailPaging(liveList));
  };
}
// #7119 END

function addOrganizerNameToObj(response, livePerformanceObj) {
  if (response && Object.prototype.hasOwnProperty.call(response, 'userList')) {
    const userList = response.userList;
    if (userList && userList.length) {
      const liveUserCountObj = userList.reduce((acc, cur) => {
        acc.bySecernId[cur.userSecernId] = cur;
        acc.allSecernIds.push(cur.userSecernId);
        const liveAllSecernIds = livePerformanceObj && livePerformanceObj.allSecernIds;
        const liveBySecernId = livePerformanceObj && livePerformanceObj.bySecernId;
        if (liveAllSecernIds && liveAllSecernIds.length > 0) {
          for (let i = 0; i < liveAllSecernIds.length; i++) {
            const { organizerUserSecernId } = liveBySecernId[liveAllSecernIds[i]];
            if (organizerUserSecernId == cur.userSecernId) {
              livePerformanceObj.bySecernId[liveAllSecernIds[i]].organizerUserName = cur.userName;
            }
          }
        }
        return acc;
      },
        {
          bySecernId: {},
          allSecernIds: [],
        });
    }
  }
  return livePerformanceObj;
}

function getOrganizerUserSecernId(liveObj) {
  const organizerUserSecernIdList = [];
  if (liveObj && liveObj.allSecernIds && liveObj.allSecernIds.length > 0) {
    for (let i = 0; i < liveObj.allSecernIds.length; i++) {
      const organizerUserSecernId = liveObj.bySecernId[liveObj.allSecernIds[i]].organizerUserSecernId;
      organizerUserSecernIdList.push(organizerUserSecernId);
    }
  }
  return organizerUserSecernIdList;
}
function getListLivePerformance(response, liveObj) {
  if (response && Object.prototype.hasOwnProperty.call(response, 'liveList')) {
    const liveListResponse = response.liveList;
    const recordNum = response.recordNum;
    if (liveListResponse && liveListResponse.length) {
      liveObj = liveListResponse.reduce((acc, cur) => {
        acc.bySecernId[cur.liveSecernId] = cur;
        acc.allSecernIds.push(cur.liveSecernId);
        return acc;
      },
        {
          bySecernId: {},
          allSecernIds: [],
        },
      );
    }
  }
  return liveObj;
}

function getListLivePerformanceUserCount(response, livePerformanceObj) {
  if (response && Object.prototype.hasOwnProperty.call(response, 'liveList')) {
    const liveListUserCountResponse = response.liveList;
    if (liveListUserCountResponse && liveListUserCountResponse.length) {
      const liveUserCountObj = liveListUserCountResponse.reduce((acc, cur) => {
        acc.bySecernId[cur.liveSecernId] = cur;
        livePerformanceObj.bySecernId[cur.liveSecernId].attendedUserCount = cur.attendedUserCount;
        livePerformanceObj.bySecernId[cur.liveSecernId].invitedUserCount = cur.invitedUserCount;
        acc.allSecernIds.push(cur.liveSecernId);
        return acc;
      },
        {
          bySecernId: {},
          allSecernIds: [],
        });
    }
  }
  return livePerformanceObj;
}

// #7129 START
export function resetLivePerformanceDetail() {
  return async dispatch => dispatch(livePerformanceCreators.resetLivePerformanceDetail());
}

// #7129 END